import { useState } from "react";
import shortid from "shortid";
import {
  Grid,
  Button,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  DatePicker,
  Loading,
  Box,
} from "../../../../components";
import { ProdutosService, notification } from "../../../../services";
import { value, InputErros } from "../../../../helpers";
import { formatPrice } from "../../../../utils";
import { DataGrid } from "@mui/x-data-grid";
import { GRID_CHECKBOX_SELECTION_COL_DEF as checkboxGrid } from "@mui/x-data-grid";

const PedidoStepperPdvContent = ({
  sendServer,
  activeStep,
  setActiveStep,
  handleImportarPedido,
  handleCancelarImportacao,
  handleDateChange,
  filtrosDialog,
  setFiltrosDialog,
  colunas,
  pedidos,
  setPedidosSelecionados,
  itensSelecionados,
  setItensSelecionados,
  buscarPedidosAvancado,
  listaClientes,
  handleInputChange,
  itemSelectionModel,
  setItemSelectionModel,
  pedidoSelectionModel,
  setPedidoSelectionModel,
  setItemEditado,
}) => {
  //service fora do componete
  const produtosService = new ProdutosService();
  const [loading, setLoading] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [itensQuantidade, setItensQuantidade] = useState([]);

  const colunasItens = [
    {
      ...checkboxGrid,
      headerClassName: "table-pdv-checkbox",
    },
    {
      field: "produto",
      headerName: "Produto",
      headerClassName: "table-pdv-header",
      flex: 500,
    },
    {
      field: "valorUnitario",
      headerName: "Valor (R$)",
      headerClassName: "table-pdv-header",
      flex: 300,
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "saldoExportar",
      headerName: "Qtd.",
      headerClassName: "table-pdv-header",
      flex: 200,
      headerAlign: "start",
      align: "start",
      type: "number",
      editable: true,
      valueParser: (newValue, params) => {
        const maxValue = itensQuantidade?.length
          ? itensQuantidade.find((item) => item.id === params.row?.id)
              ?.saldoExportar
          : params.value;
        const parsedValue = parseFloat(newValue);
        if (parsedValue > maxValue) {
          return maxValue;
        } else {
          setItemEditado(parsedValue !== maxValue);
          return parsedValue;
        }
      },
    },
    {
      field: "totalItem",
      headerName: "Total Ítem (R$)",
      headerClassName: "table-pdv-header",
      flex: 300,
      valueGetter: (params) => {
        const total = params.row.valorUnitario * params.row.saldoExportar;
        return formatPrice(total);
      },
    },
  ];

  function filtrarPedidosSelecionados(pedidosIds) {
    let pedidoImportacao = null;
    let itensImportacao = [];
    const pedidosModificados = pedidos.filter((pedido) => {
      if (pedidosIds.indexOf(pedido.id) > -1) {
        if (pedidoImportacao === null) {
          pedidoImportacao = {
            ...pedido,
          };
        }
        for (const key in pedido) {
          if (
            pedidoImportacao[key] != pedido[key] &&
            key != "id" &&
            key != "itens"
          ) {
            pedido[key] = null;
          }
        }
        if (pedidoImportacao?.clienteId == pedido.clienteId) {
          itensImportacao.push(...pedido.itens);
          return pedido;
        } else {
          setActiveStep(-1);
          return notification.alertaGenericos(
            "Pedidos devem ser do mesmo cliente"
          );
        }
      }
    });
    setPedidosSelecionados(pedidosModificados);
    buscarRelacionamentoProdutos(itensImportacao);
  }

  const handleAvancarStep = () => {
    filtrarPedidosSelecionados(pedidoSelectionModel);
    setActiveStep(activeStep + 1);
  };

  const handleVoltarStep = () => {
    setActiveStep(activeStep - 1);
  };

  const buscarRelacionamentoProdutos = async (listaItens) => {
    setLoading(true);
    const idsProdutos = listaItens.map((item) => item.produtoId);
    const filtros = {
      id: idsProdutos.length > 0 ? idsProdutos : undefined,
    };
    const res = await produtosService.getAllFiltroAvancado(filtros);
    if (!res.isAxiosError) {
      if (res.data.rows.length) {
        const itensSelecionadosTemp = listaItens
          .filter((produto) => produto.saldoExportar > 0)
          .map((produto) => {
            const produtoEncontrado = res.data.rows.find(
              (item) => item.id == produto.produtoId
            );
            return {
              ...produto,
              ...produtoEncontrado,
              id: shortid.generate(),
              produto: produtoEncontrado?.descricao ?? "",
            };
          });
          setItensQuantidade(itensSelecionadosTemp);
          setItensSelecionados(itensSelecionadosTemp);
          setItemSelectionModel(itensSelecionadosTemp.map(({ id }) => id));
      }
    }
    setLoading(false);
  };

  const onChangeAutocomplete = (name, value) => {
    setFiltrosDialog({
      ...filtrosDialog,
      [name]: value ? value.id : undefined,
    });
  };

  const onCellKeyDown = (params, event) => {
    if (event.key === "Enter") {
      setItensSelecionados((prevState) => {
        return prevState.map((row) => {
          if (params.row.id == row.id) {
            return { ...row, [params.field]: event.target.value ?? null };
          }
          return row;
        });
      });
    }
  };

  switch (activeStep) {
    case 1:
      return (
        <>
          <DialogContent>
            <Box>
              <DataGrid
                rows={itensSelecionados}
                columns={colunasItens}
                paginationMode="client"
                checkboxSelection
                rowSelectionModel={itemSelectionModel}
                onRowSelectionModelChange={(selectedIds) => {
                  setItemSelectionModel(selectedIds);
                }}
                onCellKeyDown={onCellKeyDown}
                disableColumnMenu
                hideFooter
                hideFooterPagination
                hideFooterSelectedRowCount
              />
            </Box>
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              onClick={handleCancelarImportacao}
              color="padrao"
              variant="contained"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleVoltarStep}
              color="primary"
              variant="contained"
            >
              <i
                className="ph-fill ph-caret-left"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
              Anterior
            </Button>
            <Button
              onClick={handleImportarPedido}
              color="success"
              variant="contained"
            >
              Importar
            </Button>
          </DialogActions>
          <Loading loading={loading} />
        </>
      );
    default:
      return (
        <>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <DatePicker
                  id="dataInicial"
                  name="dataInicial"
                  label="Data Inicial"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataInicial
                      ? filtrosDialog.dataInicial
                      : null
                  }
                  onChange={(date) => handleDateChange(date, "dataInicial")}
                />
              </Grid>
              <Grid item xs={4}>
                <DatePicker
                  id="dataFinal"
                  name="dataFinal"
                  label="Data Final"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataFinal ? filtrosDialog.dataFinal : null
                  }
                  onChange={(date) => handleDateChange(date, "dataFinal")}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  id="pessoaClienteId"
                  name="pessoaClienteId"
                  options={listaClientes}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.nomeRazaoSocial
                      ? `${option.id}` + ` - ` + `${option.nomeRazaoSocial}`
                      : ""
                  }
                  getOptionSelected={(option, value) =>
                    option?.nomeRazaoSocial === value?.nomeRazaoSocial
                  }
                  noOptionsText="Sem opções"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      variant={"outlined"}
                      error={inputErros.get("pessoaClienteId")}
                    />
                  )}
                  onChange={(e, value) =>
                    onChangeAutocomplete("pessoaClienteId", value)
                  }
                  value={value.autoComplete(
                    listaClientes,
                    filtrosDialog?.pessoaClienteId
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} className="mt-2 mb-4">
              <Grid item xs={4}>
                <TextField
                  id="numeroDocumento"
                  name="numeroDocumento"
                  label="Nº do documento"
                  variant="outlined"
                  value={
                    filtrosDialog.numeroDocumento
                      ? filtrosDialog.numeroDocumento
                      : undefined
                  }
                  onChange={handleInputChange}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={4} className="mt-2">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => buscarPedidosAvancado(filtrosDialog)}
                >
                  <i
                    className="ph-bold ph-magnifying-glass"
                    style={{ color: "#fff", fontSize: 18, marginRight: 8 }}
                  ></i>
                  Filtrar
                </Button>
              </Grid>
            </Grid>
            <DataGrid
              rows={pedidos}
              columns={colunas}
              checkboxSelection
              selectionModel={pedidoSelectionModel}
              onRowSelectionModelChange={(selectedIds) => {
                setPedidoSelectionModel(selectedIds);
              }}
              paginationMode={"server"}
              sendServer={sendServer}
              disableAcoes
              noFilter
              hideFooterPagination
              hideFooterSelectedRowCount
              disableColumnMenu
            />
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              onClick={handleCancelarImportacao}
              color="padrao"
              variant="contained"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => handleAvancarStep()}
              color="primary"
              disabled={pedidoSelectionModel.length == 0}
              variant="contained"
            >
              Próximo
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
            </Button>
          </DialogActions>
          <Loading loading={loading} />
        </>
      );
  }
};

export default PedidoStepperPdvContent;
